import { post } from "../utils/backend";
import { 
    GetWithdrawsForMonthParams, 
    GetWithdrawsForMonthResponse,
    AutoWithdrawJobStatus,
} from "../models/Commission";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import "./mock/CommissionMock";

const getWithdrawsForMonth = async (params: GetWithdrawsForMonthParams): Promise<GetWithdrawsForMonthResponse> => {
    if (mock) {
        return getMockData("get_withdraws_for_month");
    }
    const resultOrErrorCode = await post<GetWithdrawsForMonthParams, GetWithdrawsForMonthResponse>("/managerment/commission/getWithdrawsForMonth", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return {} as GetWithdrawsForMonthResponse;
    }
    return resultOrErrorCode;
};

const getAllWithdrawsCsvFileForMonth = async (month: string): Promise<string> => {
    if (mock) {
        return getMockData("get_all_withdraws_csv_file_for_month");
    }
    const resultOrErrorCode = await post<{ month: string }, string>("/managerment/commission/getAllWithdrawsCsvFileForMonth", { month });
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return "";
    }
    return resultOrErrorCode;
};

const markOneAsPaid = async (withdrawId: string): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<{ withdrawId: string }, boolean>("/managerment/commission/markOneAsPaid", { withdrawId });
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

const markAllAsPaid = async (): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<null, boolean>("/managerment/commission/markAllAsPaid", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

const defaultAutoWithdrawJobStatus = (): AutoWithdrawJobStatus => {
    const now = new Date();
    const month = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
    return { month, executedThisMonth: false, running: false };
};

const getAutoWithdrawJobStatus = async (): Promise<AutoWithdrawJobStatus> => {
    if (mock) {
        return getMockData("get_auto_withdraw_job_status");
    }
    const resultOrErrorCode = await post<null, AutoWithdrawJobStatus>(
        "/managerment/commission/getAutoWithdrawJobStatus",
        null
    );
    if (typeof resultOrErrorCode === "string" || !resultOrErrorCode) {
        return defaultAutoWithdrawJobStatus();
    }
    return {
        month: resultOrErrorCode.month ?? defaultAutoWithdrawJobStatus().month,
        executedThisMonth: !!resultOrErrorCode.executedThisMonth,
        running: !!resultOrErrorCode.running,
        lastRunTime: resultOrErrorCode.lastRunTime,
    };
};

const triggerAutoWithdrawJob = async (): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<null, boolean>(
        "/managerment/commission/triggerAutoWithdrawJob",
        null
    );
    if (typeof resultOrErrorCode === 'string') {
        return false;
    }
    return resultOrErrorCode;
};

export const CommissionApi = {
    getWithdrawsForMonth,
    getAllWithdrawsCsvFileForMonth,
    markOneAsPaid,
    markAllAsPaid,
    getAutoWithdrawJobStatus,
    triggerAutoWithdrawJob,
}; 